import { formatFixedDate, formatLocalDate } from '@caresend/utils';
import '../portal/store/portal/sessionStore.js';
import 'vue';
import '@caresend/types';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

const formatPatientDataOnTube = (patient) => {
    var _a;
    const store = getStore();
    return {
        patientName: (patient === null || patient === void 0 ? void 0 : patient.id)
            ? store.getters['users/getUserFullName'](patient === null || patient === void 0 ? void 0 : patient.id)
            : 'Patient Name',
        dateOfBirth: (_a = formatFixedDate(patient === null || patient === void 0 ? void 0 : patient.info.dateOfBirth, 'MM/DD/YYYY')) !== null && _a !== void 0 ? _a : 'Date of Birth',
        collectionDate: formatLocalDate(Date.now(), 'MM/DD/YYYY'),
        timeOfCollection: 'Fill out accordingly',
    };
};

export { formatPatientDataOnTube };
